import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function aliasUrlValidator(mandatoryAlias: string, optionalAliases: string[]): ValidatorFn {
  const aliasPattern = /{([^{}]+)}/g;
  const allowedAliases = [mandatoryAlias, ...optionalAliases];

  const pathAndQueryPattern = new RegExp(
    '^https?:\\/\\/' +
      '(' +
      '((?!\\{)[a-z\\d]([a-z\\d-]*[a-z\\d])*(\\.(?!\\{)[a-z\\d]([a-z\\d-]*[a-z\\d])*)+)' +
      '|' +
      '(\\d{1,3}(\\.\\d{1,3}){3})' +
      ')' +
      '(\\:\\d{1,5})?' +
      '(\\/[^\\s?#]*)*' +
      '(\\?[^\\s#]*)?' +
      '(\\#[^\\s]*)?' +
      '$',
    'i',
  );

  return (control: AbstractControl): ValidationErrors | null => {
    const url = control.value;
    if (!url) return null;

    let parsedUrl: URL;
    try {
      parsedUrl = new URL(url);
    } catch {
      return { urlInvalid: true };
    }

    const foundAliases = [...url.matchAll(aliasPattern)].map(match => match[0]);

    if (!foundAliases.includes(`{${mandatoryAlias}}`)) {
      return { mustContainMandatoryAlias: mandatoryAlias };
    }

    const invalidAlias = foundAliases.find(alias => {
      const name = alias.slice(1, -1);

      return !allowedAliases.includes(name);
    });
    if (invalidAlias) {
      return { invalidAlias };
    }

    const rawQuery = parsedUrl.search.slice(1);
    const queryParams = rawQuery ? rawQuery.split('&') : [];
    for (const param of queryParams) {
      const [key] = param.split('=');
      if (aliasPattern.test(key)) {
        return { aliasNotQueryParameter: true };
      }
    }

    const decodedPath = decodeURIComponent(parsedUrl.pathname);
    const invalidSegment = decodedPath
      .split('/')
      .filter(Boolean)
      .find(segment => /{[^{}]+}/.test(segment) && !/^\{[^{}]+\}$/.test(segment));

    if (invalidSegment) {
      return { urlInvalid: true };
    }

    let testUrl = url;
    for (const alias of allowedAliases) {
      testUrl = testUrl.replaceAll(
        `{${alias}}`,
        alias === mandatoryAlias ? 'testMandatory' : 'testOptional',
      );
    }

    if (!pathAndQueryPattern.test(testUrl)) {
      return { urlInvalid: true };
    }

    return null;
  };
}
